// Copyright (c) StrangeBee 2023

import useFilters, { FilterInputForm, ManageFiltersOutput } from '@Hooks/useFilters';
import React, { ReactElement } from 'react';
import WidgetFormFilter from './WidgetFormFilter';

interface ProvidedWidgetFormFilterProps {
    entity: string;
    onChange?: (value: FilterInputForm[]) => void;
    value?: FilterInputForm[];
    externalFilterManager?: ManageFiltersOutput;
}

const ProvidedWidgetFormFilter = ({
    entity,
    onChange,
    value,
    externalFilterManager,
}: ProvidedWidgetFormFilterProps): ReactElement => {
    const filterManager = useFilters();

    return (
        <WidgetFormFilter
            entity={entity}
            onChange={onChange}
            value={value}
            filterManager={{ ...(externalFilterManager || filterManager), editFilters: true }}
        />
    );
};

export default ProvidedWidgetFormFilter;
